// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__n+oYF","checked":"Switch_checked__dYhFf","slide":"Switch_slide__CxD8N"};